import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import styles from './index.module.css';
import { Button, Spinner } from 'react-bootstrap';

function PrimaryButton({ text = '', paddingVertical = '12px', paddingHorizontal = '20px', loading = false, ...props }) {
  return (
    <Button
      {...props}
      className={styles.btn}
      style={{
        padding: `${paddingVertical} ${paddingHorizontal}`,
      }}
      disabled={loading}
    >
      {loading ? (
        <>
          {' '}
          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Loading...{' '}
        </>
      ) : (
        <>{text}</>
      )}
    </Button>
  );
}

export default withStyles(styles)(PrimaryButton);
